import React, {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as CheckIcon} from 'assets/svg/check.svg';
import {HtmlText} from 'components/ui-kit/HTMLText';
import {Icon} from 'components/ui-kit/Icon';

import {ValidationIconWrapper, ValidationItem, ValidationList} from '../styled'; // Путь к вашим стилям

interface Props {
    watchValue: string;
}

export const PasswordValidationRules = ({watchValue}: Props) => {
    const {t} = useTranslation();

    const rules = useMemo(
        () => [
            {
                key: 'length',
                label: t('pages.password.rules.length'),
                isValid: watchValue.length >= 8 && watchValue.length <= 20,
            },
            {
                key: 'digit',
                label: t('pages.password.rules.digit'),
                isValid: /\d/.test(watchValue),
            },
            {
                key: 'alphabet',
                label: t('pages.password.rules.alphabet'),
                isValid: /[A-Za-z]/.test(watchValue),
            },
            {
                key: 'specialSymbol',
                label: t('pages.password.rules.specialSymbol'),
                isValid: /[@$!%*#?&]/.test(watchValue),
            },
        ],
        [watchValue, t],
    );

    return (
        <ValidationList>
            {rules.map((rule) => (
                <ValidationItem key={rule.key}>
                    <ValidationIconWrapper isValid={rule.isValid}>
                        {rule.isValid ? <Icon source={CheckIcon} width={20} height={20} /> : '•'}
                    </ValidationIconWrapper>
                    <HtmlText __html={rule.label} />
                </ValidationItem>
            ))}
        </ValidationList>
    );
};
